import { render, staticRenderFns } from "./Comp4.vue?vue&type=template&id=21ebe128&scoped=true&"
import script from "./Comp4.vue?vue&type=script&lang=js&"
export * from "./Comp4.vue?vue&type=script&lang=js&"
import style0 from "./Comp4.vue?vue&type=style&index=0&id=21ebe128&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebe128",
  null
  
)

export default component.exports